/**
 * Orbit Trends — focused scroll-reveal
 *
 * Replaces the dormant 973-line animation engine we stripped earlier
 * with a tight, focused Intersection Observer that adds a single class
 * (.orbit-revealed) to specific elements when they enter the viewport.
 *
 * CSS keyframes targeted at .orbit-revealed do the actual animation
 * (squiggle draw-in, fade-up, etc.) so all motion is driven from CSS,
 * which respects prefers-reduced-motion and stays GPU-accelerated.
 *
 * No global mutation, no scroll-event listeners, no setInterval —
 * just one IntersectionObserver registered on a small selector list.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    // Fallback: add the class immediately so content is visible
    document.querySelectorAll('[data-orbit-reveal], .orbit-reveal-target')
      .forEach(function (el) { el.classList.add('orbit-revealed'); });
    return;
  }

  // Heading classes that get the squiggle draw-in
  var HEADING_SELECTOR = [
    '.orbit-brands-marquee__heading',
    '.orbit-categories__heading',
    '.orbit-brand-story__heading',
    '.orbit-contact__heading',
    '.orbit-trust-newsletter__title',
    '.orbit-collection-hero__title'
  ].join(', ');

  // Generic "fade in from below" target: any section that opts in
  var REVEAL_SELECTOR = '[data-orbit-reveal], .orbit-reveal-target';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('orbit-revealed');
        io.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -8% 0px'
  });

  document.querySelectorAll(HEADING_SELECTOR + ', ' + REVEAL_SELECTOR)
    .forEach(function (el) { io.observe(el); });

  // Re-scan for dynamically inserted content (cart drawer, etc.)
  if ('MutationObserver' in window) {
    // Batched to one pass per frame; product-card appends (infinite scroll) never contain reveal targets.
    var pending = [];
    var scheduled = false;
    var flush = function () {
      scheduled = false;
      var nodes = pending;
      pending = [];
      nodes.forEach(function (node) {
        if (!node.isConnected) return;
        if (node.matches(HEADING_SELECTOR + ', ' + REVEAL_SELECTOR)) io.observe(node);
        node.querySelectorAll(HEADING_SELECTOR + ', ' + REVEAL_SELECTOR)
          .forEach(function (el) { io.observe(el); });
      });
    };
    var mo = new MutationObserver(function (records) {
      records.forEach(function (rec) {
        rec.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.product-grid__item, product-card')) return;
          pending.push(node);
        });
      });
      if (pending.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
